import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import {
  SecondAds,
  FirstAds,
  MobileUnderCalAds,
} from "../../Ads";
import { SERVER_URL } from "./ConstantsWomenCalculator";
import { PregnancyConception_EndPoint } from "./ConstantsWomenCalculator";
import { ConceptionTablev2 } from "./Tables";
import { CyrcleLengthcomponet } from "./Component";
import SharedHelmet from "../Helmet";
const TITLE = " حاسبة تاريخ الحمل والتخطيط للحمل  ";
const DESCRIPTION =
  "تقوم حاسبة تاريخ الحمل والتخطيط للحمل بتقدير تاريخ الحمل بناءً على تاريخ الاستحقاق المتوقع للحمل، تاريخ آخر دورة شهرية، أو تاريخ الأشعة فوق الصوتية. يعتبر تاريخ الحمل هو اليوم الذي يتم فيه إخصاب جنين الشخص. تقوم الحاسبة أيضًا بتقدير نطاق ممكن من الأيام التي يمكن فيها أن يؤدي الجماع الجنسي إلى الإخصاب بناءً على قدرة الحيوانات المنوية على البقاء داخل جسم المرأة لمدة 3-5 أيام.";
const KEYWORDS = "تاريخ الحمل, تخطيط للحمل, حاسبة تاريخ الحمل ";
const OG_URL = "https://do-calculate.com/calculator/ar/pregnancy-conception/";
const apiEndpoint = `${SERVER_URL}/${PregnancyConception_EndPoint}`;
function PregnancyConceptionCalculator() {
  const [firstDayOfLastPeriod, setFirstDate] = useState();
  const [periodLength, setPeriodLength] = useState(1);
  const [cycleLength, setCyrcleLength] = useState(28);
  const [result, setRestul] = useState(null);
  const [error, setError] = useState(null);
  const [statusCode, setStatusCode] = useState(null);
  const [classification, setClassification] = useState(null);
  const handleDateChange = (event) => {
    setFirstDate(event.target.value);
  };
  const calculatePregnancyConception = async () => {
    try {
      const response = await fetch(apiEndpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          firstDayOfLastPeriod,
          cycleLength,
          periodLength,
        }),
      });
      const data = await response.json();
      setStatusCode(response.status);
      if (response.ok) {
        setRestul(data.result);
        setError(null);
        setClassification(data["results"]);
      } else {
        setRestul(null);
        setError(data.error);
      }
    } catch (error) {
      console.error(error);
    }
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <b> حاسبة تاريخ الحمل والتخطيط للحمل</b>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                تقوم حاسبة تاريخ الحمل والتخطيط للحمل بتقدير تاريخ الحمل بناءً
                على تاريخ الاستحقاق المتوقع للحمل، تاريخ آخر دورة شهرية، أو
                تاريخ الأشعة فوق الصوتية. يعتبر تاريخ الحمل هو اليوم الذي يتم
                فيه إخصاب جنين الشخص. تقوم الحاسبة أيضًا بتقدير نطاق ممكن من
                الأيام التي يمكن فيها أن يؤدي الجماع الجنسي إلى الإخصاب بناءً
                على قدرة الحيوانات المنوية على البقاء داخل جسم المرأة لمدة 3-5
                أيام.
                <br />
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-12 col-md-5 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  حاسبة تاريخ الحمل والتخطيط للحمل
                </div>
                <hr />
                <br />
                <div className=" form-group d-flex align-items-center">
                  <b>
                    {" "}
                    <label className="form-label ms-2">
                      <strong>أول يوم</strong> في آخر دورة شهرية
                    </label>
                  </b>
                  <br />
                  <input
                    type="date"
                    id="weightNumber"
                    value={firstDayOfLastPeriod}
                    onChange={handleDateChange}
                    className="form-control ml-2"
                    style={{ width: "145px" }}
                    placeholder="175"
                  />
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    {" "}
                    <label htmlFor="CycleLength" className="form-label ms-2">
                      متوسط الوقت بين الدورات
                    </label>
                  </b>
                  <CyrcleLengthcomponet handleDateChange={setCyrcleLength} />
                  <div className="input-group-append">
                    <span className="input-group-text ">يوم</span>
                  </div>
                </div>
                <br />
                <hr />
                <div>
                  <button
                    className="btn btn-success"
                    style={{ fontSize: "20px" }}
                    onClick={calculatePregnancyConception}
                  >
                    إحسب{" "}
                  </button>
                </div>
              </div>
              <div className="col-12 col-md-7">
                <br />
                {statusCode === 400 && (
                  <div className="alert alert-warning">
                    <b>
                      <u> حدث خطأ :</u>
                    </b>{" "}
                    يُرجى إدخال جميع الحقول بالشكل الصحيح.{" "}
                  </div>
                )}
                {result && (
                  <div>
                    <h4>
                      <div className="p-3 mb-2 bg-success text-white">
                        النتائج:{" "}
                      </div>
                    </h4>
                    <hr />
                    <ConceptionTablev2 result={result}></ConceptionTablev2>
                  </div>
                )}
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                وصف حاسبة تاريخ الحمل والتخطيط للحمل :{" "}
              </div>
              <div className="info-section-body">
                <u>
                  <b>متى حدثت الإخصاب؟ </b>{" "}
                </u>
                <br />
                متى بالضبط تم حدوث الحمل؟ يطرح العديد من النساء هذا السؤال عند
                محاولة معرفة اليوم الدقيق الذي بدأت فيه حملهن. غالبًا ما يتم
                حساب العمر الجنيني، أو عمر الجنين، من اليوم الأول لآخر فترة
                شهرية للأم. من الناحية البيولوجية، لم يتم إخصاب الجنين حتى حدوث
                التبويض وتلقيح البويضة، والذي يحدث عادة بعد مضي على الأقل 10
                أيام من اليوم الأول لآخر فترة شهرية للأم.
                <br/>                نظرًا لوجود العديد من العوامل المحيطة بالإخصاب، من الصعب تحديد
                تاريخ الإخصاب بدقة. تساعد هذه الحاسبة على تقدير نطاق تاريخ
                الإخصاب الحقيقي ونطاق ممكن من الأيام التي يمكن فيها أن يؤدي
                الجماع الجنسي إلى الإخصاب. هناك بعض الطرق التي يمكن استخدامها
                لتقدير تواريخ الإخصاب.
                <br/>                <u>
                  <b>آخر دورة شهرية</b>{" "}
                </u>
                <br />
                يحدث الإخصاب عادة بين 11-21 يومًا بعد أول يوم للدورة الشهرية
                الأخيرة للمرأة التي لديها دورة منتظمة. يستند تقدير تاريخ الإخصاب
                على هذا النطاق، ولكنه نادراً ما يكون دقيقًا تمامًا لأنه من الصعب
                معرفة متى يحدث التبويض بالضبط. يمكن أن يكون تقدير تاريخ الإخصاب
                أكثر صعوبة أيضًا بالنسبة للنساء اللواتي يعانين من دورات غير
                منتظمة، أو لأولئك اللاتي لا يتذكرن أول يوم للدورة الشهرية
                الأخيرة. في حالات مثل هذه، يُعتبر إحدى الطرق الأكثر دقة لتقدير
                العمر الجنيني هو استخدام الأشعة فوق الصوتية.
                <br/>                <u>
                  <b>التلقيح، الإخصاب، والحمل</b>{" "}
                </u>
                <br />
                التلقيح والإخصاب هما مصطلحان يستخدمان بشكل متبادل في كثير من
                الأحيان. تستخدم هذه الحاسبة تعريف الأطباء والعلماء لهاتين
                المصطلحين. يحدث التلقيح عندما يتحد الحيوان المنوي والبويضة في
                قناة فالوب، مكونين بذلك بويضة مخصبة، ويبدأ بذلك العملية التي
                يتطور فيها الجنين.
                <br/>                الإخصاب يشير إلى عملية الحمل، والتي تشمل علميًا كل من التلقيح
                وزراعة الجنين في جدار الرحم. على المستوى الولائي (في الولايات
                المتحدة)، هناك بعض الارتباك في استخدام مصطلحات الإخصاب والتلقيح
                نظرًا لاختلاف التعاريف المستخدمة. في بعض الحالات، تُعتبر المرأة
                حامل بعد التلقيح، ولكن هذا لا يتوافق مع التعاريف العلمية والطبية
                المرسومة بشكل جيد. الرأي القائم منذ فترة طويلة لدى العاملين في
                المجال الطبي، وكذلك السياسات الحكومية (في الولايات المتحدة)،
                يعتبر المرأة حامل عندما يتم زراعة البويضة المخصبة في جدار الرحم.
                عند حدوث ذلك، يُقال إن المرأة تكون حبلت. بعبارة أخرى، الإخصاب من
                الناحية الطبية والعلمية يتطلب كل من التلقيح والزراعة، ولا يُعتبر
                المرأة حامل حتى يحدث كليهما.
                <br/>                <hr />
                <b>تاريخ اخر مراجعة : </b>
                28/02/2026
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default PregnancyConceptionCalculator;
